import React, { useContext, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import "../CSS/header.css";
import { MenuContext } from "../App";

function Header() {
  const progressBar = useRef(null);
  const [progress, setProgress] = useState(0);
  const [isTop, setIsTop] = useState(true);
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);

  const handleMenu = () => {
    setIsMenuClicked(!isMenuClicked);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      const documentHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      setProgress((scrollPos * 100) / documentHeight);

      scrollPos > 0 ? setIsTop(false) : setIsTop(true);
    });
  }, []);

  // progressBar.current.addEventListener('')
  return (
    <div className="fixed z-10 w-full py-1 flex flex-col justify-center items-center">
      {isTop && (
        <div id="top_header" className="pb-2 tracking-wider">
          <p>For any assistance, call us at [+91- 7895927366].</p>
        </div>
      )}
      <div className="w-full flex items-center justify-between bg-slate-100 px-10 md:px-20">
        <div>
          <NavLink to="/">
            <img src="logo/logo.png" alt="Logo" className="w-14 md:w-20" />
          </NavLink>
        </div>
        <div className="hidden w-full md:flex justify-center gap-x-10 text-lg">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/solutions">Solutions</NavLink>
          <NavLink to="/clients">Clients</NavLink>
          <NavLink to="/partners">Partners</NavLink>
          <NavLink to="/about">About Us</NavLink>
          <NavLink to="/contact-us">Contact Us</NavLink>
        </div>
        <div className="md:hidden relative w-32 flex justify-end">
          <button onClick={handleMenu}>
            <img src="icons/Menu.png" alt="Hamburger Menu" className="w-7" />
          </button>
          {isMenuClicked && (
            <div className="absolute top-10  py-3 gap-y-3 bg-slate-100 w-32 flex flex-col items-center tracking-wider rounded-lg">
              <NavLink to="/">Home</NavLink>
              <NavLink to="/solutions">Solutions</NavLink>
              <NavLink to="/clients">Clients</NavLink>
              <NavLink to="/partners">Partners</NavLink>
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/contact-us">Contact Us</NavLink>
            </div>
          )}
        </div>
      </div>
      <div className="w-full h-1 bg-slate-100">
        <div
          ref={progressBar}
          className="bg-[#4A57BF] h-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
}

export default Header;
